import React, { useRef, useState } from "react";
import {
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import ButtomSave from "../../components/ButtomSave";
import { LoadingSpinner } from "../../components/Loading";
import { InvoiceTypes } from "../../lib/interfaces";
import axios from "axios";
import PaymentStatus from "../../components/PaymanetStatus";
import { QRCodeCanvas } from "qrcode.react";
import { isMobile } from "react-device-detect";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";
import { HandleShare } from "../../lib/utils";

interface Props {
  invoice: InvoiceTypes
  wide?: boolean
}

type IconKey = "error" | "success" | "processing";

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentPixAreaCliente: React.FC<Props> = ({ invoice, wide }) => {

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();

  const[ text, set_text] = useState("Copiar código Pix");
  const [loading, set_loading] = useState(false);
  const { set_sync_invoices } = useStore();
  const { user } = useStore();
  const { external_link } = useStore();
  const [status_pix, set_status_pix] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invoice.pix);
    } catch (err) {}
  };

  //Resolver código comentado aqui
  const ClosePaymentPix = () => {
    setTimeout(() => {
      onClose();
      set_status_pix({
        icon: "processing",
        legend: "",
        open: false,
        title: "",
      });
      set_text("Copiar código Pix");
    }, 4000);
  };

  const VerifyStatusPix = async () => {
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/get_status_invoice",
        {
          id_fatura: invoice.id_fatura.toString(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );
      if (resposta.data.status_code === 200) {
        if (resposta.data.status_invoice === "pending") {
          set_loading(true);
        }
        if (resposta.data.status_invoice === "canceled") {
          stopInterval();
          set_loading(false);
          set_status_pix({
            icon: "error",
            legend:
              "Houve uma falha no pagamento, tente novamente ou troque o método de pagamento.",
            open: true,
            title: "Falha no pagamento",
          });
          ClosePaymentPix();
          AmplitudeLog("Falha_pix_pagamento", { user_id: user });
        }
        if (resposta.data.status_invoice === "paid") {
          set_loading(false);
          stopInterval();
          set_status_pix({
            icon: "success",
            legend: "O pagamento foi aprovado com sucesso!",
            open: true,
            title: "Pagamento aprovado!",
          });
          ClosePaymentPix();
          set_sync_invoices(true);
          AmplitudeLog("Sucesso_pix_pagamento", { user_id: user });
        }
      } else {
        set_status_pix({
          icon: "error",
          legend: "Houve uma falha no pagamento" + resposta.data.msg,
          open: true,
          title: "Falha no pagamento",
        });
        stopInterval();
        ClosePaymentPix();
        AmplitudeLog("Falha_pix_pagamento", { user_id: user });
      }
    } catch (erro: any) {
      stopInterval();
      set_status_pix({
        icon: "error",
        legend: "Ocorreu uma falha de comunicação com o sistema",
        open: true,
        title: "Falha de comunicação",
      });
      ClosePaymentPix();
    }
  };

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startInterval = () => {
    AmplitudeLog("Aguardando_pix_pagamento", { user_id: user });
    setTimeout(()=> {
      if (intervalRef.current) return;
      VerifyStatusPix();
      intervalRef.current = setInterval(() => {
        VerifyStatusPix();
      }, 20000);
    }, 1000)
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      <ButtonMethodPayment
        icon="pix"
        theme="white"
        onClick={() => {
          AmplitudeLog("Op_pix_pagamento", { user_id: user });
          onOpen();
        }}
        wide={wide}
      >
        Pague com Pix
      </ButtonMethodPayment>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() => {
          stopInterval();
          set_loading(false);
          set_status_pix({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          });
        }}
      >
        <DrawerContent
          className={`
            w-ful
            rounded-t-[0.75rem]
            !max-h-screen ${
              !isMobile && "!h-[100vh] !rounded-none !border-none"
            }
            bg-white-primary
            px-[2rem]
            pb-[2rem]
            flex
            items-center
          `}
        >
          {(onClose) => (
            <div
              className={`${external_link && !isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={()=> {onClose(); set_text("Copiar código Pix")}}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <div className="w-[100%] flex justify-center">
                <p className="text-blue-primary text-[1.04rem] font-[700]">
                  Pagamento com Pix
                </p>
              </div>
              <p className="text-gray-dark text-[1.04rem] mt-[1.8rem] font-[700]">
                Fatura
              </p>
              <Invoice
                duedate={invoice?.vencimento}
                price={invoice?.preco}
                theme="default"
              />
              <PaymentStatus
                icon={status_pix.icon}
                legend={status_pix.legend}
                open={status_pix.open}
                title={status_pix.title}
              />
              <hr />
              {!loading ? (
                <div>
                  <p className="text-gray-dark text-[1rem] mt-[1.75rem] font-[700]">
                    QR Code
                  </p>
                  <p className="">Aponte a câmera do celular para pagar</p>
                  <div className="flex justify-center my-[1.8rem]">
                    <QRCodeCanvas
                      value={invoice?.pix}
                      size={120}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                    />
                  </div>
                  <div
                    className={`flex  ${
                      !isMobile ? "flex-row" : "flex-col"
                    }  gap-[0.75rem]`}
                  >
                    <ButtomSave
                      icon="copy"
                      theme="mediumgreen"
                      onClick={() => {
                        AmplitudeLog("Copiar_pix_pagamento", { user_id: user });
                        handleCopy();
                        startInterval();
                        set_text("Código Pix copiado!");
                      }}
                    >
                      {text}
                    </ButtomSave>
                    {external_link === false && isMobile && (
                      <ButtomSave
                        icon="share"
                        theme="white"
                        onClick={() => {
                          AmplitudeLog("Compartilhar_pix_pagamento", {
                            user_id: user,
                          });
                          HandleShare(invoice.pix);
                          startInterval();
                        }}
                      >
                        Compartilhar
                      </ButtomSave>
                    )}
                  </div>
                  <div className="flex flex-row items-center mt-[1rem] mb-[1rem]">
                    <p className="mr-1">Já fez o pagamento?</p>
                    <p
                      className="underline decoration-solid text-gray-dark"
                      onClick={() => {
                        startInterval();
                        AmplitudeLog("Pago_pix_pagamento", {
                            user_id: user,
                        });
                      }}
                    >
                      Clique aqui
                    </p>
                  </div>
                </div>
              ) : (
                <div className="w-[100%] flex items-center flex-col mt-[1.5rem]">
                  <LoadingSpinner className="w-[3.12rem] h-[3.12rem] text-green-medium" />
                  <p className="text-gray-dark text-[1.12rem] mt-[1.25rem] font-[700]">
                    Pagamento sendo processado
                  </p>
                </div>
              )}
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentPixAreaCliente;
